import { lazy, Suspense, FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// types
import { BuyerChatLazy_viewer as Viewer } from './__generated__/BuyerChatLazy_viewer.graphql';

const LazyComponent = lazy(
    () => import(/* webpackChunkName: "BuyerChat" */ './BuyerChatRespContainer')
);

type Props = {
    viewer: Viewer;
    isInitiallyMinimized: boolean;
    draftedMessage?: string | null;
};

export const BuyerChatLazyComponent: FC<Props> = props =>
    props.viewer ? (
        <Suspense fallback="">
            <LazyComponent {...props} />
        </Suspense>
    ) : null;

export const BuyerChatLazy = createFragmentContainer(BuyerChatLazyComponent, {
    viewer: graphql`
        fragment BuyerChatLazy_viewer on Viewer {
            ...BuyerChatRespContainer_viewer
        }
    `,
});
